import gsap from "gsap";

export default function Accordion() {
  Alpine.data("accordion", () => ({
    openIndex: null,

    init() {
      this.$el.querySelectorAll("[data-accordion-panel]").forEach((panel) => {
        gsap.set(panel, { display: "none", height: 0, overflow: "hidden" });
      });
    },

    toggle(index) {
      const panels = this.$root.querySelectorAll("[data-accordion-panel]");
      const target = panels[index];

      if (!target) return;

      if (this.openIndex === index) {
        gsap.to(target, {
          height: 0,
          duration: 0.35,
          ease: "power2.out",
          onComplete: () => gsap.set(target, { display: "none" }),
        });
        this.openIndex = null;
      } else {
        if (this.openIndex !== null) {
          const prev = panels[this.openIndex];
          if (prev) {
            gsap.to(prev, {
              height: 0,
              duration: 0.35,
              ease: "power2.out",
              onComplete: () => gsap.set(prev, { display: "none" }),
            });
          }
        }

        gsap.set(target, { display: "block", overflow: "hidden" });
        const fullHeight = target.scrollHeight;
        gsap.fromTo(
          target,
          { height: 0 },
          { height: fullHeight, duration: 0.35, ease: "power2.out" },
        );
        this.openIndex = index;
      }
    },

    isOpen(index) {
      return this.openIndex === index;
    },
  }));
}
